var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBolt(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 29,
    viewBox: "0 0 26 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.8176 0.109085C15.347 0.342097 15.6615 0.901094 15.59 1.48175L14.4726 10.5455H24.7C25.2044 10.5455 25.6633 10.8414 25.8773 11.3045C26.0912 11.7677 26.0216 12.3146 25.6987 12.7075L12.6987 28.5256C12.3292 28.9752 11.7117 29.1239 11.1824 28.8909C10.653 28.6579 10.3385 28.0989 10.41 27.5182L11.5274 18.4545H1.30001C0.795592 18.4545 0.336703 18.1586 0.122749 17.6955C-0.091204 17.2323 -0.0215955 16.6854 0.301328 16.2925L13.3013 0.474374C13.6708 0.024831 14.2883 -0.123927 14.8176 0.109085ZM4.07556 15.8182H13C13.3729 15.8182 13.7278 15.9805 13.9746 16.264C14.2214 16.5474 14.3362 16.9247 14.29 17.2999L13.5399 23.3839L21.9244 13.1818H13C12.6271 13.1818 12.2722 13.0195 12.0254 12.736C11.7786 12.4526 11.6638 12.0753 11.71 11.7002L12.4601 5.6161L4.07556 15.8182Z",
    fill: "#5FFFA0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBolt);
export default __webpack_public_path__ + "static/media/bolt.cce35864d6e86482ccb76a96a09be01b.svg";
export { ForwardRef as ReactComponent };